import {
  EDITING_DOCUMENTS_LIST_DELETE_FAILURE,
  EDITING_DOCUMENTS_LIST_DELETE_REQUEST,
  EDITING_DOCUMENTS_LIST_DELETE_SUCCESS,
} from '@app/store/actionTypes';
import { EditingDocumentsAction } from '@app/store/editingDocuments/actions';

type EditingDocumentsIsDeletingState = boolean;

const initialState: EditingDocumentsIsDeletingState = false;

export default function reducer(
  state: EditingDocumentsIsDeletingState = initialState,
  action: EditingDocumentsAction
) {
  switch (action.type) {
    case EDITING_DOCUMENTS_LIST_DELETE_REQUEST:
      return true;
    case EDITING_DOCUMENTS_LIST_DELETE_SUCCESS:
    case EDITING_DOCUMENTS_LIST_DELETE_FAILURE:
      return false;
    default:
      return state;
  }
}
